import React, { useEffect, useRef, useState } from "react";
import "./ChatWindow.css";
import { useChat } from "../Layout/ChatProvider/ChatProvider";
import Message from "./Message/Message";
import { Message as MessageType } from "../../../types/Message";

interface ChatWindowProps {
    messages?: MessageType[];
}

const ChatWindow: React.FC<ChatWindowProps> = ({ messages: propMessages }) => {
    const { loading, messages: contextMessages, companyId, setCompanyId } = useChat();
    const messagesEndRef = useRef<HTMLDivElement>(null);
    const messages = propMessages || contextMessages;
    const hasMessages = (messages?.length ?? 0) > 0;

    useEffect(() => {
        const savedCompanyId = localStorage.getItem("selectedCompanyId");
        if (savedCompanyId) {
            setCompanyId(savedCompanyId);
        }
    }, []);

    useEffect(() => {
        if (companyId) {
            localStorage.setItem("selectedCompanyId", companyId);
        }
    }, [companyId]);

    useEffect(() => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [messages]);

    return (
        <div className="chat-window">
            <div className="header">
                {(!companyId || !hasMessages) && <div className="chat-avatar">HK</div>}
                {!companyId && (
                    <p className="hello-message">
                        Please select a company to start a conversation.
                    </p>
                )}
                {companyId && loading && (
                    <p className="hello-message">Loading messages...</p>
                )}
                {companyId && !loading && !hasMessages && (
                    <p className="hello-message">How can I help you today?</p>
                )}
            </div>
            {hasMessages && (
                <div className="chat-messages">
                    {messages.map((msg) => (
                        <Message key={msg.id} message={msg} />
                    ))}
                    <div ref={messagesEndRef} />
                </div>
            )}
        </div>
    );
};

export default ChatWindow;
